export default {
  add: () => import("/home/gpotter/projects/gitOfs/vue/ofsprojects/layouts/add.vue"),
  default: () => import("/home/gpotter/projects/gitOfs/vue/ofsprojects/layouts/default.vue")
}